
import { InjectionToken } from '@angular/core';

// https://stackblitz.com/edit/netanel-control-er?file=src%2Fapp%2Fform-submit.directive.ts,package.json

export const defaultErrors = {
  // required: (error) => `This field is required`,
  minlength: ({ requiredLength, actualLength }) => `Expect ${requiredLength} but got ${actualLength}`
}

export const FORM_ERRORS = new InjectionToken('FORM_ERRORS', {
  providedIn: 'root',
  factory: () => defaultErrors
});
